import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { length } from 'redux-form-validators';
import { toPlainObject, isEmpty } from 'lodash';

import { HIDE_EMAIL_OPTIN } from '../../../../constants';
import {
    ADDRESS_LENGTH,
    CITY_LENGTH,
    PHONE_LENGTH,
    POSTCODE_LENGTH
} from '../../../../constants/form';
import { MADAME, MONSIEUR } from '../../../../constants/civilities';

import {
    sendProfileUpdateRequest,
    reset,
    setTimeoutId
} from '../../../../services/account/myprofile/actions';

import { mapCountries } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import {
    CheckboxInputFieldComponent,
    EmailInputFieldComponent,
    FormComponent,
    LegendFieldComponent,
    PhoneInputFieldComponent,
    SelectFieldComponent,
    TextInputFieldComponent
} from '../../../../components/form';
import ErrorMessageComponent from '../../../form-message/ErrorMessageComponent';
import SuccessMessageComponent from '../../../form-message/SuccessMessageComponent';

import './ProfileFormComponent.scss';

const FORM_NAME = 'profile-form';

class ProfileFormComponent extends React.Component {
    componentWillUnmount() {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
    }

    submit = formData => {
        const { sendProfileUpdateRequest, timeoutId } = this.props;

        clearTimeout(timeoutId);
        sendProfileUpdateRequest(formData);
    };

    handleCloseMessage = () => {
        const { reset, timeoutId } = this.props;
        clearTimeout(timeoutId);
        reset();
    };

    getCivilities = () => {
        const { i18nForm } = this.props;

        return [
            { label: i18nForm.CIVILITIES.MONSIEUR, value: MONSIEUR },
            { label: i18nForm.CIVILITIES.MADAME, value: MADAME }
        ];
    };

    render() {
        const {
            i18n,
            i18nForm,
            BRAND_NAME_ALT,
            BRAND_NAME_ALT_2,
            COMPANY_NAME,
            isAuthed,
            COUNTRIES,
            initialValues,
            requestSubmit,
            errorSubmit,
            errorMessage,
            successProfilSubmit
        } = this.props;

        return (
            <React.Fragment>
                <FormComponent
                    form={FORM_NAME}
                    initialValues={isAuthed ? initialValues : {}}
                    classNameInputContainer="grid-3 has-gutter"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.BUTTON_VALIDATE}>
                    <EmailInputFieldComponent
                        name="email"
                        label={i18n.LABEL_EMAIL}
                        classNameInputContainer="one-half mr50"
                        readOnly
                    />
                    <LegendFieldComponent classNameInputContainer="full">
                        {convertHtmlToReactDomWithParams(
                            i18n.UPDATABLE_ADDRESS_FIELD,
                            COMPANY_NAME,
                            BRAND_NAME_ALT,
                            BRAND_NAME_ALT_2
                        )}
                    </LegendFieldComponent>

                    <LegendFieldComponent classNameInputContainer="full separation">
                        <hr />
                    </LegendFieldComponent>

                    <SelectFieldComponent
                        name="civility"
                        classNameInputContainer="one-quarter mr75"
                        label={i18nForm.LABEL_CIVILITY}
                        defaultOptionLabel={i18nForm.LABEL_CIVILITY}
                        options={this.getCivilities()}
                        isRequired
                    />
                    <TextInputFieldComponent
                        name="lastname"
                        label={i18nForm.LABEL_LASTNAME}
                        placeholder={i18nForm.LABEL_LASTNAME}
                        classNameInputContainer="one-quarter"
                        validate={[length({ max: 20, msg: i18nForm.LASTNAME_SIZE_ERROR })]}
                        isRequired
                    />
                    <TextInputFieldComponent
                        name="firstname"
                        label={i18nForm.LABEL_FIRSTNAME}
                        placeholder={i18nForm.LABEL_FIRSTNAME}
                        classNameInputContainer="one-quarter mr50"
                        validate={[length({ max: 20, msg: i18nForm.FIRSTNAME_SIZE_ERROR })]}
                        isRequired
                    />
                    <TextInputFieldComponent
                        name="address"
                        classNameInputContainer="one-half"
                        placeholder={i18nForm.LABEL_ADDRESS}
                        label={i18nForm.LABEL_ADDRESS}
                        validate={[
                            length({
                                max: ADDRESS_LENGTH,
                                msg: format(i18nForm.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="postcode"
                        classNameInputContainer="one-quarter"
                        placeholder={i18nForm.LABEL_ZIPCODE}
                        label={i18nForm.LABEL_ZIPCODE}
                        maxLength={POSTCODE_LENGTH}
                        validate={[
                            length({
                                max: POSTCODE_LENGTH,
                                msg: format(i18nForm.ZIP_CODE_SIZE_ERROR, POSTCODE_LENGTH)
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="city"
                        classNameInputContainer="one-quarter"
                        placeholder={i18nForm.LABEL_CITY}
                        label={i18nForm.LABEL_CITY}
                        validate={[
                            length({
                                max: CITY_LENGTH,
                                msg: format(i18nForm.CITY_SIZE_ERROR, CITY_LENGTH)
                            })
                        ]}
                    />
                    <SelectFieldComponent
                        name="country"
                        classNameInputContainer="one-quarter"
                        label={i18nForm.LABEL_COUNTRY}
                        defaultOptionLabel={i18nForm.LABEL_COUNTRY}
                        options={COUNTRIES}
                    />
                    <PhoneInputFieldComponent
                        name="phoneNumber"
                        label={i18nForm.LABEL_PHONENUMBER}
                        classNameInputContainer="one-quarter"
                        validate={[
                            length({
                                max: PHONE_LENGTH,
                                msg: i18nForm.PHONENUMBER_SIZE_ERROR
                            })
                        ]}
                    />
                    {!HIDE_EMAIL_OPTIN && (
                        <CheckboxInputFieldComponent
                            name="newsletter"
                            classNameInputContainer="three-quarters mt30"
                            options={[
                                {
                                    label: convertHtmlToReactDomWithParams(
                                        i18n.TEXT_NEWSLETTER,
                                        BRAND_NAME_ALT_2
                                    ),
                                    value: 1
                                }
                            ]}
                        />
                    )}

                    <LegendFieldComponent classNameInputContainer="full">
                        {i18nForm.MANDATORY_FIELD}
                    </LegendFieldComponent>
                </FormComponent>

                <ErrorMessageComponent visible={errorSubmit} message={errorMessage} />
                <SuccessMessageComponent
                    visible={successProfilSubmit}
                    message={i18n.CONFIRM_UPDATE_PERSONAL_DATA}
                    onClose={this.handleCloseMessage}
                />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18nForm: state.i18n.feature.form,
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT,
        BRAND_NAME_ALT_2: state.i18n.common.BRAND_NAME_ALT_2,
        COMPANY_NAME: state.i18n.common.COMPANY_NAME,
        isAuthed: !isEmpty(state.authentication.token),
        COUNTRIES: mapCountries(state.i18n.feature.form.COUNTRIES),
        initialValues: {
            civility: user.civility ? user.civility : '',
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : '',
            address: user.address ? user.address : '',
            postcode: user.postcode ? user.postcode : '',
            city: user.city ? user.city : '',
            country: user.country ? user.country : '',
            phoneNumber: user.mobileNumber ? user.mobileNumber : '',
            ...(HIDE_EMAIL_OPTIN
                ? {}
                : { newsletter: user.activeMailingOffer ? user.activeMailingOffer : false })
        },
        requestSubmit: state.account.myprofile.fetching,
        errorSubmit: !isEmpty(state.account.myprofile.error),
        errorMessage: state.account.myprofile.error,
        successProfilSubmit: state.account.myprofile.successProfileUpdateRequestSubmit,
        timeoutId: state.account.myprofile.resetTimeoutId
    };
}

const mapDispatchtoProps = {
    sendProfileUpdateRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchtoProps)(ProfileFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfileFormComponent.js